<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="12">
        <Aviso
          mensagem="Cálculo de acordo com as Decisões TCDF 2625/2021, 56/2022 e Portaria 407/2011."
        />
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col cols="11">
        <v-simple-table dense>
          <template v-slot:default>
            <thead class="text-center">
              <tr>
                <th class="text-center">
                  Período
                </th>
                <th class="text-center">
                  Correção Monetária
                </th>
                <th class="text-center">
                  Juros Mensais
                </th>
              </tr>
            </thead>
            <tbody class="text-center">
              <tr>
                <th>até 31/08/2001</th>
                <td>INPC</td>
                <td>1,0%</td>
              </tr>
              <tr>
                <th>01/09/2001 a 29/06/2009</th>
                <td>INPC</td>
                <td>0,5%</td>
              </tr>
              <tr>
                <th>a partir de 30/06/2009</th>
                <td>IPCA-15</td>
                <td>juros da poupança</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col cols="8">
        <FormCalculo tipo="3013">
          <template v-slot:jurosDatePicker="{ habilitarDataJuros }">
            <DatePicker
              :habilitarDataJuros="habilitarDataJuros"
              ref="dataJurosDatePicker"
              nome="Data de início da incidência dos juros"
              regras="data"
              tipo="dataJuros"
              dica="Juros e/ou multa (essa a partir de 2020) incidentes em casos de dolo e mora"
            />
          </template>
        </FormCalculo>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col cols="12">
        <Resultados3013 />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import FormCalculo from "@/components/FormCalculo.vue";
import Resultados3013 from "@/components/Resultados3013.vue";
import Aviso from "@/components/Aviso.vue";
import DatePicker from "@/components/DatePicker.vue";
export default {
  components: {
    FormCalculo,
    Resultados3013,
    Aviso,
    DatePicker
  }
};
</script>

<style lang="scss" scoped></style>
